
































import { Component, Vue, Prop } from 'vue-property-decorator';
import EventBus from '../event-bus';
import moment from 'moment';

@Component({
    filters: {
        moment: function(timestamp: number) {
            return moment.unix(timestamp).format("DD/MM/YYYY HH:mm");
        }
    }
})
export default class ChooseEmergencyPopup extends Vue {
    show_modal : boolean = false;

    saving: boolean = false;
    message: any = 0;
    emergencyList: Array<any> = [];
    selectEmergency: number = 0;
    errorMessage: string = '';

    async associateEmergency() {
        const formRes = this.$el.querySelector( 'form' );
        const form = formRes ? <HTMLFormElement>formRes[ 0 ] : null;

        if( form && !form.reportValidity() )
            return;
        let data = new FormData();
        data.append( 'message_id', this.message.id.toString() );
        try
        {
            this.saving = true;
            const resp = await this.$http({
                method: 'POST',
                url: '/emma/admin/emergencies/' + this.selectEmergency.toString() + '/message',
                data: data
            });
            EventBus.$emit( 'remove-warning', this.message );
        }
        catch( e )
        {
            this.errorMessage = 'Si è verificato un errore: ' + e;
        }
        finally
        {
            this.saving = false;
        }
        
        this.close();
    }

    async show()  {
        this.emergencyList = (await this.$http.get( '/emma/admin/emergencies/active' )).data;
        this.show_modal = true;
    }

    close() {
        this.show_modal = false;
        this.errorMessage = '';
        this.saving = false;
        this.emergencyList = [];
        this.message = null;
    }
}
